import moment from "moment";

const TINYURL_EXPIRATION_DATE_PLACEHOLDER = `E.g. ${moment()
  .add(4, "years")
  .format("MMM D, YYYY hh:mm A")}`;

export { TINYURL_EXPIRATION_DATE_PLACEHOLDER };
